import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Projects } from "../Data/Data";
import Section from "../components/Section";
import LeftSide from "../components/Apartments/LeftSide";
import RightSide from "../components/Apartments/RightSide";
import { ApartmentsTypes } from "../Data/ApartmentsTypes";
import { delayNavigation, getApartmentTypeByIds } from "../helpers/helpers";
import { TbEye } from "react-icons/tb";
import { useDispatch } from "react-redux";

const Apartments = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedProject, setSelectedProject] = useState({});
  const [apartmentsList, setApartmentsList] = useState([]);
  const [fillters, setFillters] = useState({
    floors: [],
    types: [],
    sizes: [],
  });
  useEffect(() => {
    setFillters({
      floors: [],
      types: [],
      sizes: [],
    });
  }, [location.pathname]);
  // console.log(fillters);
  useEffect(() => {
    const projectName = location.pathname.split("/")[2];
    const projectObj = Projects.find(
      (project) => project.name.toLowerCase() === projectName.toLowerCase()
    );
    // console.log(projectObj.name);

    setSelectedProject(projectObj);

    const getFilteredApartments = (project, filters) => {
      return project.floors.flatMap((floor) => {
        if (
          filters.floors.length > 0 &&
          !filters.floors.includes(floor.floorNumber)
        ) {
          return [];
        }

        return floor.apartmens
          .map((apartment) => {
            const apartmentDetailsObject = getApartmentTypeByIds(
              apartment.typeId,
              apartment.subTypeId,
              ApartmentsTypes,
              projectObj
            );
            // console.log(floor, apartment.number);
            const typeMatch =
              filters.types.length === 0 ||
              filters.types.includes(apartment.typeId);

            const sizeMatch =
              filters.sizes.length === 0 ||
              filters.sizes.some(
                (size) =>
                  apartmentDetailsObject.apartmentSubTypeObject.size >=
                    size.min &&
                  apartmentDetailsObject.apartmentSubTypeObject.size <= size.max
              );

            if (typeMatch && sizeMatch) {
              return {
                ...apartment,
                typeImg: apartmentDetailsObject.apartmentTypeObject.img,
                size: apartmentDetailsObject.apartmentSubTypeObject.size,
                typelabel: apartmentDetailsObject.apartmentTypeObject.label,
                subTypelabel:
                  apartmentDetailsObject.apartmentSubTypeObject.label,
                floor: floor.floorNumber,
              };
            }
            return null;
          })
          .filter(Boolean);
      });
    };

    const filteredApartments = getFilteredApartments(projectObj, fillters);
    setApartmentsList(filteredApartments);
  }, [location.pathname, fillters]);

  return (
    <Section bg={"bg-inherit"}>
      <h3 className="text-2xl xl:text-5xl font-bold uppercase tracking-widest text-primary-bg-blue col-start-2 my-12 flex items-center gap-4 ">
        apartments
        <div
          className="xl:hidden w-6 h-6 rounded-full flex items-center justify-center bg-primary-orange"
          onClick={() => {
            delayNavigation(
              dispatch,
              navigate,
              `${location.pathname.replace("apartments", "block")}`
            );
          }}
        >
          <TbEye className="text-primary-light w-6 h-6 " />
        </div>
      </h3>
      <main className="col-span-10 col-start-2 xl:grid grid-cols-1 xl:grid-cols-12 max-h-fit mb-32 ">
        <LeftSide
          projectsList={Projects}
          selectedProject={selectedProject}
          setSelectedProject={setSelectedProject}
          fillters={fillters}
          setFillters={setFillters}
        />
        <RightSide
          selectedProject={selectedProject}
          apartmentsList={apartmentsList}
        />
      </main>
    </Section>
  );
};

export default Apartments;
